module.exports = __webpack_public_path__ + "static/media/greenhouse2Step12-6.df3e2484.png";